import React, { Component } from "react";
import { Carousel } from "react-responsive-carousel";
import Blazy from '../../../../managers/blazy';
import delayPageTransitions from '../../../../util/delayPageTransitions';
import { tabletBreakpoint } from '../../../../constants/breakpoints';
import Slider from 'react-slick';
import Lightbox from "react-images";
import Point from '../../../../util/point';
import SessionDataManager from '../../../../util/storage-manager';
import { getDictionary } from '../../../../util/dictionary';
import { handleSearchFlights } from "../../BookingJourney/MiniBasket/utils/flights";
import MiniBasketOverlay from "./mini-basket-overlay";
import Rectangle from '../../../../util/rectangle';
import ViewMoreImages from "./ViewMoreImages/ViewMoreImages";

const MAX_DOWN_PRESS_TIME = 1000;
const MAX_MOVE_DISTANCE = 50;
const SLIDESHOW_BREAKPOINT = tabletBreakpoint;

export default class HeroCarousel extends Component {
  constructor(props) {
    super(props);

    this.state = {
      images: [],
      hasLoaded: false,
      showLink: false,
      lightboxIsOpen: false,
      currentLightboxImage: 0
    };

    this.onChange = this.onChange.bind(this);
    this.openLightbox = this.openLightbox.bind(this);
    this.closeLightbox = this.closeLightbox.bind(this);
    this.gotoNext = this.gotoNext.bind(this);
    this.gotoPrevious = this.gotoPrevious.bind(this);
    this.checkToAllowClick = this.checkToAllowClick.bind(this);
    this.getEventData = this.getEventData.bind(this);
    this.onPointerDown = this.onPointerDown.bind(this);
  }

  componentDidUpdate() {
    Blazy.revalidate();
    delayPageTransitions();
    if (this.state.showAsSlideshow && this.state.images.length >= 3) {
      const slickWrapperElement = document.querySelector('.sov-hero-slider-wrapper');
      if (slickWrapperElement) {
        slickWrapperElement.addEventListener('pointerdown', this.onPointerDown, true);
      }
    }
  }

  componentWillMount() {
    let { dataset } = this.props.context;

    const miniBasketData = dataset.miniBasket;
    const showMiniBasketOverlay = miniBasketData !== "null" && miniBasketData !== undefined;

    if (showMiniBasketOverlay) {
      const data = SessionDataManager.getStorage();
      const basket = data.basket;
      const currentHotel = data.currentHotel;
      const returnedSearch = JSON.parse(sessionStorage.getItem('returnedSearch'));
      const carHires = JSON.parse(sessionStorage.getItem('carHires'));
      const selectedHotel = currentHotel.AccommodationAvailability[currentHotel.activeIndex];
      const transfer = selectedHotel.Transfer === "" ? "No Transfer" : selectedHotel.Transfer;
      const searchExtras = selectedHotel.BestRoomOptions[0].Extras.concat(selectedHotel.BestRoomOptions[0].RoomInclusions);
      let extras = [];
      if (searchExtras) {
        searchExtras.forEach(element => {
          let extra = {
            Name: element,
            Comment: null
          }
          extras.push(extra);
        });
      }
      let flights = null;
      if (selectedHotel.OutBoundFlight && selectedHotel.InBoundFlight) flights = handleSearchFlights(selectedHotel);
      getDictionary('Mini Basket', (dictionary) => {
        this.setState({
          basket,
          carHires,
          dictionary,
          extras,
          flights,
          miniBasketData,
          returnedSearch,
          selectedHotel,
          showMiniBasketOverlay,
          transfer
        });

      });
    }
  }

  componentDidMount() {
    let { dataset } = this.props.context;
    const { carouselVersion, imageCaption, showAsSlideshow } = dataset;
    let showLink = imageCaption !== "True";
    let images = [];
    let allImages = [...document.querySelectorAll("[data-carousel-image]")];
    let foundImages = allImages;
    if (carouselVersion) {
      foundImages = foundImages.filter(foundImage => foundImage.dataset.carouselVersion === carouselVersion);
    }
    // ensure image dimensions are the same as the single image implementation in Carousel.cshtml and CarouselWithBanner.cshtml
    const { height, width } = this.getImageDimensions();

    let lightboxImages = [];
    let reactSlickImages = [];
    for (let i = 0; i < foundImages.length; ++i) {

      const imageSrc = foundImages[i].getAttribute("data-carousel-image") || '';
      const queryDelimiter = imageSrc.indexOf('?') > -1 ? '&' : '?';
      foundImages[i].style.display = 'none';
      images.push({
        imageContent: {
          title: foundImages[i].dataset.carouselTitle,
          subtitle: foundImages[i].dataset.carouselSubtitle,
          summary: foundImages[i].dataset.carouselSummary,
          btnText: foundImages[i].dataset.carouselBtn,
          url: foundImages[i].dataset.carouselUrl,
          altText: foundImages[i].dataset.carouselImageAlt,
          footerText: foundImages[i].dataset.carouselFooter,
          linkText: foundImages[i].dataset.carouselLinkText,
          linkUrl: foundImages[i].dataset.carouselLinkUrl,
          focalPointX: foundImages[i].dataset.carouselFocalPointX,
          focalPointY: foundImages[i].dataset.carouselFocalPointY,
        },
        hasContent: foundImages[i].dataset.carouselHasContent,
        backgroundImage: imageSrc + queryDelimiter + "h=" + height + "&w=" + width,
        placholderImage: imageSrc + queryDelimiter + "mw=50",
        isHalfHeight: foundImages[i].getAttribute("data-half") === "True",
        isBigger: foundImages[i].getAttribute("data-bigger") === "True",
        isMidSize: foundImages[i].getAttribute("data-mid") === "True",
        height,
        width,
      });

      const lightboxImageObject = {
        src: `${imageSrc}${queryDelimiter}h=${height * 2}&w=${width * 2}`,
        alt: foundImages[i].dataset.carouselImageAlt,
      };
      const slickImageObject = {
        ...lightboxImageObject,
        src: `${imageSrc}${queryDelimiter}h=${height}&w=${width}`,
      }
      reactSlickImages.push(slickImageObject);
      lightboxImages.push(lightboxImageObject);
    }

    this.setState({
      showAsSlideshow: showAsSlideshow === 'True',
      images,
      showLink,
      lightboxImages,
      reactSlickImages,
    });

    setTimeout(() => {
      this.setState({ hasLoaded: true });
    }, 500);
  }

  getImageDimensions = () => {
    // get carousel dimensions
    let { dataset, clientHeight: height, clientWidth: width } = this.props.context;
    const { showAsSlideshow } = dataset;
    const { devicePixelRatio, innerWidth } = window;

    // If we can see the next and previous images (image width is halved)
    if (innerWidth > SLIDESHOW_BREAKPOINT && showAsSlideshow === 'True') {
      width /= 2;
    }

    // If we're on a high pixel ratio device (e.g. mobile)
    if (devicePixelRatio >= 1) {
      width = width * devicePixelRatio;
      height = height * devicePixelRatio;
    }

    return {
      width,
      height,
    }
  }

  openLightbox(event) {
    const miniBasketElement = document.querySelector('.MiniBasketOverlay');
    if (miniBasketElement) {
      const miniBasketBox = miniBasketElement.getBoundingClientRect();
      let bounds = new Rectangle(miniBasketBox.left, miniBasketBox.top, miniBasketBox.width, miniBasketBox.height);
      const isClickWithinMiniBasketOverlay = bounds.contains(event.clientX, event.clientY);

      if ((this.state.showMiniBasketOverlay && !isClickWithinMiniBasketOverlay && this.checkToAllowClick(event)) || (!this.state.showMiniBasketOverlay && this.checkToAllowClick(event))) {
        this.setState({ lightboxIsOpen: true });
      }
    }
  }

  getEventData(event) {
    return {
      point: new Point(event.screenX, event.screenY),
      time: new Date().getTime(),
    };
  }

  onPointerDown(event) {
    this.downData = this.getEventData(event);
  }

  checkToAllowClick(event) {
    let allowed = true;
    if (this.downData) {
      const eventData = this.getEventData(event);
      if (eventData.time > this.downData.time + MAX_DOWN_PRESS_TIME) {
        allowed = false;
      }

      if (Point.distance(eventData.point, this.downData.point) > MAX_MOVE_DISTANCE) {
        allowed = false;
      }

      if (event.target.classList.contains("slick-arrow")) {
        allowed = false;
      }
    }

    this.downData = undefined;
    return allowed;
  }

  closeLightbox() {
    this.setState({ lightboxIsOpen: false });
  }

  gotoPrevious() {
    this.setState({
      currentLightboxImage: this.state.currentLightboxImage - 1
    });
  }

  gotoNext() {
    this.setState({
      currentLightboxImage: this.state.currentLightboxImage + 1
    });
  }


  onChange() {
    setTimeout(() => {
      Blazy.revalidate();
      delayPageTransitions();
    }, 500);
  }


  render() {
    const { context: { dataset }} = this.props;
    const {
      lightboxImages,
      lightboxIsOpen,
      currentLightboxImage,
      dictionary,
      showAsSlideshow,
      miniBasketData,
      selectedHotel,
      flights,
      extras,
      transfer,
      carHires,
      returnedSearch,
      showMiniBasketOverlay,
    } = this.state;

    let array = [];
    let reactSlickArray = [];
    let divStyle = {
      top: window.scrollTop + 'px'
    };

    let visiableClass = this.state.hasLoaded ? "loaded" : "";

    for (let i = 0; i < this.state.images.length; i++) {
      // class for setting height: 500 or 250
      let imageClass = "hero_default-image";
      let imageBg = this.state.images[i].backgroundImage;
      let placholderImage = this.state.images[i].placholderImage;
      let altText = "Carousel image";
      if (this.state.images[i].imageContent.altText != "") {
        altText = this.state.images[i].imageContent.altText;
      }

      if (this.state.images[i].isHalfHeight) {
        imageClass = "b-lazy no-logo hero_250-image";
      } else if (this.state.images[i].isBigger) {
        imageClass = "b-lazy no-logo hero_500-image";
      } else if (this.state.images[i].isMidSize) {
        imageClass = "b-lazy no-logo hero_510-image";
      }

      if (this.state.images[i].hasContent) {
        imageClass = "b-lazy no-logo hero_banner-image";
      }

      const focalPointX = this.state.images[i].imageContent.focalPointX;
      const focalPointY = this.state.images[i].imageContent.focalPointY;
      const focalPointString = `${focalPointX}% ${focalPointY}%`;
      const { src } = this.state.reactSlickImages[i]
      const { height, width } = this.state.images[i]
      if (showMiniBasketOverlay) {
        reactSlickArray.push(
          <div className="heroCarousel_hotelContainer">
            <img
              key={i}
              alt={altText}
              className="hero-miniBasket hero_hotel-image b-lazy no-logo"
              src={src}
              height={height}
              width={width}
            ></img>
          </div>
        );
      } else {
        reactSlickArray.push(
          <div>
            <img
              key={i}
              alt={altText}
              className="b-lazy no-logo hero_hotel-image"
              src={src}
              height={height}
              width={width}
            ></img>
          </div>
        );
      }
      array.push(
        <div key={i}>
          <div className={imageClass} src={placholderImage} data-src={imageBg} aria-label={altText} style={{ backgroundPosition: focalPointString }}>
            <div className="HeroInsideWrapper">
              {dataset && dataset.feefoUrl &&
                <div className="heroCarousel_feefoContainer">
                  <img className="heroCarousel_feefoImage" src={dataset.feefoUrl} alt="Feefo review image" loading="lazy" />
                </div>
              }
              {this.state.images[i].hasContent && (
                <div className="HeroInsideContent">
                  <div className="HeroInsideContent_title" dangerouslySetInnerHTML={
                    { __html: this.state.images[i].imageContent.title }
                  }></div>
                  <h5 className="HeroInsideContent_text">
                    {
                      this.state.images[i]
                        .imageContent.summary
                    }
                  </h5>
                  {this.state.images[i].imageContent.url && this.state.images[i].imageContent.btnText && (
                    <a
                      href={
                        this.state.images[i]
                          .imageContent.url
                      }
                      className="HeroInsideContent_button btn"
                    >
                      {this.state.images[i].imageContent.btnText}
                      <i className="HeroInsideContent_buttonIcon fa fa-arrow-right"></i>
                    </a>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      );
    }
    const slideshowSettings = {
      dots: true,
      infinite: true,
      initialSlide: 0,
      speed: 500,
      slidesToScroll: 1,
      slidesToShow: 2,
      arrows: true,
      dots: true,
      centerMode: true,
      className: `sov-hero-slider ${showMiniBasketOverlay ? "heroCarousel_hotelContainer" : ""}`,
      accessibility: true,
      draggable: true,
      useCSS: true,
      responsive: [
        {
          breakpoint: SLIDESHOW_BREAKPOINT,
          settings: {
            centerPadding: '0%',
            slidesToShow: 1,
            centerMode: false,
            arrows: false
          }
        }
      ],
      afterChange: this.onChange,
      beforeChange: this.onChange
    };
    return (
      <div className={`heroCarousel ${visiableClass}${miniBasketData ? " heroCarousel-miniBasket" : ""}`} style={divStyle}>
        <div className="heroCarousel_overlay">
        </div>
        {(array.length > 0 && !showAsSlideshow ||
          array.length <= 3 && showAsSlideshow) && (
            <Carousel
              axis="horizontal"
              showThumbs={false}
              showArrows={true}
              showIndicators={array.length > 1 ? true : false}
              showStatus={false}
              emulateTouch={false}
              infiniteLoop={true}
              swipeScrollTolerance={100}
              onChange={this.onChange}
              className={`${showMiniBasketOverlay ? "heroCarousel_hotelContainer" : ""}`}
            >
              {array}
            </Carousel>
          )}
        {array.length > 3 && showAsSlideshow && (
          <div className="heroCarousel_outerContainer">
            <div className={`sov-hero-slider-wrapper ${showMiniBasketOverlay ? "heroCarousel_hotelContainer" : ""}`} onClick={(event) => this.openLightbox(event)}>
              <Slider {...slideshowSettings}>
                {reactSlickArray}
              </Slider>
              {
                /* Desktop minibasket under carousel */
                showMiniBasketOverlay &&
                <MiniBasketOverlay
                  carHires={carHires}
                  dictionary={dictionary}
                  extras={extras}
                  flights={flights}
                  isDesktop={true}
                  miniBasketModel={miniBasketData}
                  search={returnedSearch}
                  selectedHotel={selectedHotel}
                  transfer={transfer}
                />
              }
              <Lightbox
                clickOutsideToClose={true}
                currentImage={currentLightboxImage}
                images={lightboxImages}
                isOpen={lightboxIsOpen}
                onClickNext={this.gotoNext}
                onClickPrev={this.gotoPrevious}
                onClose={this.closeLightbox}
                width="90vw"
              />
            </div>
          </div>
        )}
        {/* Mobile minibasket under carousel */}
        {showMiniBasketOverlay &&
          <MiniBasketOverlay
            carHires={carHires}
            dictionary={dictionary}
            extras={extras}
            flights={flights}
            isDesktop={false}
            miniBasketModel={miniBasketData}
            search={returnedSearch}
            selectedHotel={selectedHotel}
            transfer={transfer}
          />
        }
        <ViewMoreImages
          customClass="heroCarousel_viewMoreImages"
          onClick={() => this.setState({ lightboxIsOpen: !this.state.lightboxIsOpen })}
        />
      </div>
    );
  }
}
